import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IonNav, ModalController } from '@ionic/angular';
import * as moment from 'moment';
import { CommonService } from 'src/app/services/common.service';
import { CardService } from 'src/app/services/card.service';
import { CaseService } from 'src/app/services/case.service';
import { Subscription } from 'rxjs';
import { AddressDetailsPage } from '../../../../address-details/address-details.page';
import { AuthService } from 'src/app/services/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-trustpayment-card',
  templateUrl: './trustpayment-card.page.html',
  styleUrls: ['./trustpayment-card.page.scss'],
})
export class TrustPaymentCardPage implements OnInit {
  caseId;
  @Input() debtorId = localStorage.getItem('debtor_id');
  @Input() planType = 'plan';
  @Input() selectedPlanData;
  @Input() caseData;
  selectedCases = [];
  debtorDetails;
  @Input() paymentMethod;
  addCardForm: FormGroup;
  datemin = moment().format('YYYY-MM-DD');
  datemax = moment().add('100', 'years').format('YYYY-MM-DD');
  savedCardList = [];
  debtorDetailsSubscription: Subscription;
  caseDetailsSubscription: Subscription;
  paymentGatewayList = [];
  savedCards = [];
  isGroupArrangement = false;
  groupArrId;
  caseList = [];
  billingAddress = [];
  selectedBillingAddress;
  saveBtnDisabled = false;
  paymentGatewayTemplate;
  amount; //add
  frequency; //add
  firstPaymentDate; //date
  paymentMethods = [
    { id: 1, label: 'Cash' },
    { id: 2, label: 'Cheque' },
    { id: 4, label: 'Credit card', name: 'card' },
    { id: 5, label: 'Debit Card', name: 'bank' },
    { id: 8, label: 'BACS' },
  ];
  method = null;
  outstanding;
  planText: any;
  showOption: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private cardService: CardService,
    private caseService: CaseService,
    private modalController: ModalController,
    private authService: AuthService,
    private ionNav: IonNav,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    const paymentData = this.caseService.paymentData;
    this.paymentMethod = paymentData.paymentMethod;
    this.amount = paymentData.amount;
    this.frequency = paymentData.freq;
    this.firstPaymentDate = paymentData.date;
    this.outstanding = paymentData.total;
    this.caseList = paymentData.caseList;
    if (this.planType == 'group_plan') {
      this.caseId = this.caseData[0].id;
    } else {
      this.caseId = paymentData.caseId;
    }
    let portalSettings = JSON.parse(localStorage.getItem('portal_settings'));
    console.log("portalSettings", portalSettings);
    if (
      portalSettings.payment_method_list &&
      Object.values(portalSettings.payment_method_list)
    ) {
      this.paymentMethods = [];
      const payment_method_list = portalSettings.payment_method_list;
      Object.keys(payment_method_list).forEach((key) => {
        this.paymentMethods.push({
          id: parseInt(key),
          label: payment_method_list[key],
        });
      });
    }
    if (portalSettings?.gateway_templates?.trustpayment?.card_recurring_payment) {
      this.paymentGatewayTemplate =
        portalSettings.gateway_templates.trustpayment.card_recurring_payment;
    }
    this.method = this.paymentMethods[0].id
      ? this.paymentMethods[0].id.toString()
      : '';
    this.initForm();
    this.getDebtorDetails();
    this.getCaseDetails();
  }
  async ionViewWillEnter() {
    this.getCardDetails();
  }
  getDebtorDetails() {
    this.debtorDetailsSubscription = this.authService
      .getdebtorDetailsData()
      .subscribe((res: any) => {
        if (res && res.result) {
          this.debtorDetails = res.data;
          this.updateFormData(res.data);
          this.billingAddress = res.data.addresses.map((add) => {
            return this.getBillingAddress(add);
          });
          if (this.billingAddress[0])
            this.selectedBillingAddress = this.billingAddress[0];
        }
      });
  }
  updateFormData(data) {
    const updatedValues = {
      debtor_name: data.debtor_name || '',
      debtor_email: data.debtor_email || '',
      address_ln1: data?.addresses[0]?.address_ln1
        ? data.addresses[0]?.address_ln1
        : '',
      address_ln2: data?.addresses[0]?.address_ln2
        ? data.addresses[0]?.address_ln2
        : '',
      address_ln3: data?.addresses[0]?.address_ln3
        ? data.addresses[0]?.address_ln3
        : '',

      address_town: data?.addresses[0]?.address_town
        ? data.addresses[0]?.address_town
        : '',
      address_postcode: data?.addresses[0]?.address_postcode
        ? data.addresses[0]?.address_postcode
        : '',
    };
    Object.keys(updatedValues).forEach((key) => {
      this.addCardForm.controls[key].setValue(updatedValues[key]);
    });
  }
  removeBillingAddress() {
    this.selectedBillingAddress = null;
  }
  getCaseDetails() {
    this.caseDetailsSubscription = this.caseService
      .getCaseDetailsData()
      .subscribe((res: any) => {
        if (res && res.result) {
          this.paymentGatewayList = res.data.paymentGatewayList;
          this.getCards();
        }
      });
  }

  ngOnDestroy(): void {
    if (this.caseDetailsSubscription) {
      this.caseDetailsSubscription.unsubscribe();
    }
    if (this.debtorDetailsSubscription) {
      this.debtorDetailsSubscription.unsubscribe();
    }
  }

  getCardDetails() {
    if (this.paymentMethod) {
      let method = '';
      let id = this.debtorId;
      const linkedCases = this.selectedCases;
      let grpSelCases = '';
      if (linkedCases.length) {
        method = 'group';
        linkedCases.push(this.caseId);
        linkedCases.forEach((element) => {
          grpSelCases += element + '@@';
        });
        id = grpSelCases;
      }
      this.cardService
        .getSavedCards(id, this.paymentMethod, method)
        .subscribe((res) => {
          if (res) {
            const cards = [];
            Object.keys(res).forEach((element) => {
              cards.push({ key: element, value: res[element] });
            });
            this.savedCardList = cards;
          }
        });
    }
  }
  initForm() {
    this.addCardForm = this.formBuilder.group({
      card_number: [
        '',
        [Validators.required, Validators.pattern('^[0-9]{12,20}$')],
      ],
      card_expiry: ['', [Validators.required]],
      card_cvc: ['', [Validators.required, Validators.pattern('^[0-9]{3,4}$')]],
      debtor_name: [
        this.debtorDetails?.debtor_name ? this.debtorDetails.debtor_name : '',
        [Validators.required],
      ],
      address_ln1: [
        this.debtorDetails?.addresses[0]?.address_ln1
          ? this.debtorDetails.addresses[0]?.address_ln1
          : '',
        [Validators.required],
      ],
      address_ln2: [
        this.debtorDetails?.addresses[0]?.address_ln2
          ? this.debtorDetails.addresses[0]?.address_ln2
          : '',
        [],
      ],
      address_ln3: [
        this.debtorDetails?.addresses[0]?.address_ln3
          ? this.debtorDetails.addresses[0]?.address_ln3
          : '',
        [],
      ],
      address_town: [
        this.debtorDetails?.addresses[0]?.address_town
          ? this.debtorDetails.addresses[0]?.address_town
          : '',
        [Validators.required],
      ],
      address_postcode: [
        this.debtorDetails?.addresses[0]?.address_postcode
          ? this.debtorDetails.addresses[0]?.address_postcode
          : '',
        [Validators.required],
      ],
      repeatPayment: [true, []], //done
      payment_method: [null, []], // done
      payment_card_list: [],
      selectedLinkCaseIds: [[]],
      method: [this.method, []],
    });
  }
  getBillingAddress(add) {
    const address_ln1 = add?.address_ln1 ? add?.address_ln1 + ', ' : '';
    const address_ln2 = add?.address_ln2 ? add?.address_ln2 + ', ' : '';
    const address_ln3 = add?.address_ln3 ? add?.address_ln3 + ', ' : '';
    const address_town = add?.address_town ? add?.address_town + ', ' : '';
    const address_postcode = add?.address_postcode ? add?.address_postcode : '';
    return (
      address_ln1 + address_ln2 + address_ln3 + address_town + address_postcode
    );
  }

  setLatestCard() {
    if (
      this.addCardForm.value.payment_method == 'sagePay' &&
      this.savedCards.length > 0
    ) {
      let payment_card_list = this.addCardForm.controls.payment_card_list;
      payment_card_list.setValue(
        this.savedCards[this.savedCards.length - 1].key
      );
    }
  }
  isAddressMissing() {
    const value = this.addCardForm.value;
    if (
      !value['address_town'] ||
      !value['address_postcode'] ||
      !value['address_ln1']
    )
      return true;
    return false;
  }
  async changeAddress() {
    const values = this.addCardForm.value;
    const address = {
      address_ln1: values.address_ln1,
      address_ln2: values.address_ln2,
      address_ln3: values.address_ln3,
      address_town: values.address_town,
      address_postcode: values.address_postcode,
    };
    const requiredAddress = {
      address_ln1: true,
      address_town: true,
      address_postcode: true,
    };
    const modal = await this.modalController.create({
      component: AddressDetailsPage,
      componentProps: {
        address,
        requiredAddress,
        setAddress: (data) => {
          Object.keys(data).forEach((key) => {
            this.addCardForm.controls[key].setValue(data[key]);
          });
        },
      },
    });
    return await modal.present();
  }

  getCards() {
    if (this.addCardForm.value.payment_method) {
      let method = '';
      let id = this.debtorId;
      const linkedCases = this.addCardForm.value.selectedLinkCaseIds;
      let grpSelCases = '';
      if (linkedCases.length) {
        method = 'group';
        linkedCases.push(this.caseId);
        linkedCases.forEach((element) => {
          grpSelCases += element + '@@';
        });
        id = grpSelCases;
      }
      this.cardService
        .getSavedCards(id, this.addCardForm.value.payment_method, method)
        .subscribe((res) => {
          if (res) {
            const cards = [];
            Object.keys(res).forEach((element) => {
              cards.push({ key: element, value: res[element].last_digits });
            });
            this.savedCards = cards;
            setTimeout(() => {
              this.setLatestCard();
            }, 100);
          }
        });
    }
  }

  repeatPaymentSelected(event) {
    let payment_card_list = this.addCardForm.controls.payment_card_list;
    let payment_method = this.addCardForm.controls.payment_method;
    if (event.detail.checked) {
      payment_card_list.setValidators([Validators.required]);
      payment_card_list.updateValueAndValidity();
      payment_method.setValidators([Validators.required]);
      payment_method.updateValueAndValidity();
      if (this.paymentGatewayList.length > 0) {
        payment_method.setValue(this.paymentGatewayList[0].key);
        this.getCards();
      }
    } else {
      payment_card_list.clearValidators();
      payment_card_list.reset();
      payment_card_list.updateValueAndValidity();
      payment_method.clearValidators();
      payment_method.reset();
      payment_method.updateValueAndValidity();
    }
  }
  save() {
    this.addCardForm.markAllAsTouched();
    if (this.addCardForm.valid) {
      this.commonService.showLoader();
      const trustpaymentObj = {
        amount: this.amount ? this.amount : this.outstanding,
        freq: this.frequency,
        start: this.firstPaymentDate,
        ref_amount: this.outstanding,
        debtor_name: this.addCardForm.value.debtor_name,
        card_number: this.addCardForm.value.card_number,
        cvv: this.addCardForm.value.card_cvc,
        expiry_month: moment(this.addCardForm.value.card_expiry).format('MM'),
        expiry_year: moment(this.addCardForm.value.card_expiry).format('YYYY'),
        address_ln1: this.addCardForm.value.address_ln1,
        address_ln2: this.addCardForm.value.address_ln2,
        address_ln3: this.addCardForm.value.address_ln3,
        town: this.addCardForm.value.address_town,
        address_postcode: this.addCardForm.value.address_postcode,
        //other than recurring form values
        debtor_id: this.debtorDetails.debtor_id,
        mode: 'make',
        payment_method: 'trust_payment', //'trustpayment'
        //extra fields
        // repeatPayment: this.addCardForm.value.repeatPayment,
        method: this.addCardForm.value.method,
        // is_group: this.planType == 'group_plan' ? 1 : 0,
        // cases: this.caseList,
      };
      this.caseService
        .newRecurringCardPaymentPlan(this.caseId, trustpaymentObj)
        .subscribe((res: any) => {
          this.saveBtnDisabled = false;
          this.commonService.dismissLoader();
          if (res.status == 200) {
            let toastMessage = this.translate.instant(
              'PAYMENT.ACTION_PERFORMED_SUCCESSFULLY'
            );
            let toastType = 'success';
            if (!res.data.success) {
              toastMessage = res.data.message;
              toastType = 'danger';
            } else {
              this.caseService.saveCaseDetails(
                localStorage.getItem('debtor_id')
              );
              this.ionNav.popToRoot();
            }
            this.commonService.showToast(toastMessage, toastType);
          } else {
            this.commonService.showToast(res['message'], 'danger');
          }
        });
    } else {
      const keys = Object.keys(this.addCardForm.controls);
      for (let key of keys) {
        if (!this.addCardForm.controls[key].valid) {
          if (
            ['address_postcode', 'address_town', 'address_ln1'].includes(key)
          ) {
            this.commonService.showToast(
              this.translate.instant('PAYMENT.ADDRESS_REQUIRES_VALUE', { key }),
              'danger'
            );
            return;
          }
          this.commonService.showToast(
            this.translate.instant('PAYMENT.CHECK_VALUE', { key }),
            'danger'
          );
          return;
        }
      }
    }
  }
  async dismiss() {
    this.ionNav.pop();
  }

  toggleOptions(value) {
    this.showOption = value == false ? true : false;
  }
}
